import { createBaseEndpoints } from './baseEndpoints';
import { createEntityEndpoints } from './entityEndpoints';
import { createEventQueryEndpoints } from './eventEndpoints';
export const allSubgraphEndpoints = {
    endpoints: (builder) => Object.assign(createBaseEndpoints(builder), createEntityEndpoints(builder), createEventQueryEndpoints(builder)),
};
//# sourceMappingURL=allSubgraphEndpoints.js.map